class ShowSelectedContent extends HTMLElement {
  constructor() {
    super();

    this.buttons = this.querySelectorAll('[data-target]');
    this.contents = this.querySelectorAll('[data-content]');

    if (!this.buttons.length || !this.contents.length) {
      return;
    }

    this.init();
  }

  init() {
    // WCAG
    this.buttons.forEach(button => {
      button.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          button.click();
        }
      })
    })

    this.buttons.forEach(button => {
      button.addEventListener('click', () => {
        const target = button.getAttribute('data-target');

        this.contents.forEach(content => {
          const contentId = content.getAttribute('data-content');

          if (contentId === target) {
            return content.removeAttribute('hidden');
          }

          content.setAttribute('hidden', '');
        });
      });

    });
  }
}

customElements.define('show-selected-content', ShowSelectedContent);